import React from "react";
import "./Updates.css";

const Updates = () => {
  const videos = [
    require("../assets/kmv-v1.mp4"),
       require("../assets/kmv-v2.mp4"),
  ];

  return (
    <section className="updates-section">
        <div className="home-gallery-top">
          <h2 className="home-gallery-heading">
           Updates
          </h2>

          <p className="home-gallery-text">
     केएमवी कॉलेज की नवीनतम गतिविधियों एवं महत्वपूर्ण अपडेट्स से जुड़े रहें।
          </p>
        </div>
      <div className="updates-container">
        {videos.map((video, index) => (
          <div className="updates-video-card" key={index}>
            <video
              src={video}
              controls
              playsInline
              preload="metadata"
            />
          </div>
        ))}
      </div>
    </section>
  );
};

export default Updates;